
    import './styles.scoped.css';
    export default {
  "toggle": "awsui_toggle_1uo6m_zen78_97",
  "drawer-triggers": "awsui_drawer-triggers_1uo6m_zen78_102",
  "drawer": "awsui_drawer_1uo6m_zen78_102",
  "drawer-mobile": "awsui_drawer-mobile_1uo6m_zen78_112",
  "drawer-closed": "awsui_drawer-closed_1uo6m_zen78_115",
  "drawer-content": "awsui_drawer-content_1uo6m_zen78_123",
  "non-interactive": "awsui_non-interactive_1uo6m_zen78_141",
  "trigger": "awsui_trigger_1uo6m_zen78_149",
  "trigger-drawer": "awsui_trigger-drawer_1uo6m_zen78_160",
  "selected": "awsui_selected_1uo6m_zen78_160"
};
  